module.exports = __webpack_public_path__ + "img/c00_buildingtechmurderholes_Normal_ua.a16a86b6.webp";